import axios from 'axios'

export default {
    get: () => axios.get('events-planners'),
    getDefault: () => axios.get('events-planners/default'),
    store: (data) => axios.post('events-planners/store', data),
    update: (data) => axios.post('events-planners/update', data),
    delete: (id) => axios.post('events-planners/delete', id)
}